import * as Yup from 'yup';
import i18n from '../../i18n';

const SignInValidation = () =>
  Yup.object().shape({
    email: Yup.string()
      .email(i18n.t('invalidEmail'))
      .required(i18n.t('validation.required')),
    password: Yup.string().required(i18n.t('validation.required')),
  });

const ForgotPasswordValidation = () =>
  Yup.object().shape({
    email: Yup.string()
      .email(i18n.t('invalidEmail'))
      .required(i18n.t('validation.required')),
  });
const phoneRegExp = /^\+?\d{8,}$/;
const ResetPasswordValidation = () =>
  Yup.object().shape({
    code: Yup.string().required(i18n.t('validation.required')),
    password: Yup.string()
      .required(i18n.t('validation.required'))
      .min(6, i18n.t('validation.tooShort')),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref('password'), null],
      i18n.t('passwordsMustMatch')
    ),
  });
const RegistrationValidation = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .min(2, i18n.t('validation.tooShort'))
      .max(50, i18n.t('validation.tooLong'))
      .required(i18n.t('validation.required')),
    lastName: Yup.string()
      .min(2, i18n.t('validation.tooShort'))
      .max(50, i18n.t('validation.tooLong'))
      .required(i18n.t('validation.required')),
    merchantName: Yup.string()
      .required(i18n.t('validation.required'))
      .min(2, i18n.t('validation.tooShort')),
    email: Yup.string()
      .email(i18n.t('invalidEmail'))
      .required(i18n.t('validation.required')),
    password: Yup.string()
      .required(i18n.t('validation.required'))
      .min(6, i18n.t('validation.tooShort')),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref('password'), null],
      i18n.t('passwordsMustMatch')
    ),
    // token: Yup.string().required(i18n.t('validation.required')),
    localPhone: Yup.string()
      .matches(/^\d+$/, i18n.t('validation.invalidNumber'))
      .matches(phoneRegExp, i18n.t('validation.invalidPhoneNumber'))
      .required(i18n.t('validation.required')),
    countryCode: Yup.string().required(i18n.t('validation.required')),
    timezone: Yup.string().required(i18n.t('validation.required')),
  });
const RegistrationConfirmationValidation = () =>
  Yup.object().shape({
    code: Yup.string().required(i18n.t('validation.required')),
  });
export {
  SignInValidation,
  ForgotPasswordValidation,
  ResetPasswordValidation,
  RegistrationValidation,
  RegistrationConfirmationValidation,
};
